import { ClickableTile } from '@carbon/react';
import { Rocket } from '@carbon/react/icons';
import moment from 'moment';
import type { InterestWorkspaceResponse } from 'types/api-responses';
import style from './workspace-tile.module.scss';

interface WorkspaceTileProps {
  workspace: InterestWorkspaceResponse;
  onClick: (workspace: InterestWorkspaceResponse) => void;
}

export const WorkspaceTile = ({ workspace, onClick }: WorkspaceTileProps) => {
  return (
    <ClickableTile className={style.tile} onClick={() => onClick(workspace)}>
      <div className={style.name}>{workspace.name}</div>
      {workspace.description && (
        // Wraps over as many lines as it needs; the native title tooltip is
        // kept so the full text is also available on hover. A
        // Carbon tooltip renders a <button>, which would be invalid nested
        // inside this ClickableTile and would swallow the row's navigation.
        <div className={style.description} title={workspace.description}>
          {workspace.description}
        </div>
      )}
      <div className={style.creator}>{workspace.createdByName}</div>
      <div className={style.date}>
        Created: {moment(workspace.createdAt).format('MMM D, YYYY')}
      </div>
      {workspace.promoted && (
        <div className={style.promoted}>
          <Rocket size={12} aria-hidden />
          Promoted
        </div>
      )}
    </ClickableTile>
  );
};
